import './about.css';

export default function About() {

    return (
      <div className="about">
        <h2>About</h2>
        <h3>What is Tri-connect?</h3>
        <p>Tri-connect is a turn-based game for three players. You place and move your pieces. The first player to connect all five pieces in a straight line is the winner.</p>
        <hr></hr>
        <h3>Creator</h3>
        <p>Martin Stojanović</p>
        <p>Software Engineer</p>
        <hr></hr>
        <h3>Contact me</h3>
        <p>If you have any suggestions on how to improve the game or you notice any bugs, feel free to contact me.</p>
        <p><a href="mailto:martinstojanovic96@gmail.com?subject=Tri-Connect">martinstojanovic96@gmail.com</a></p>
      </div>
    )

}
